import {
  Box,
  chakra,
  Container,
  Link,
  SimpleGrid,
  Text,
  VisuallyHidden,
  useColorModeValue,
  Flex,
  HStack,
  VStack,
  Divider,
  Image,
  useColorMode,
} from "@chakra-ui/react";
import { FaTelegram, FaTwitter } from "react-icons/fa";

const Logo = (props) => {
  const { colorMode } = useColorMode();
  return (
    <Image
      src={
        colorMode === 'light' 
          ? require('../assets/img/logo/logo_dark.png')
          : require('../assets/img/logo/logo_light.png')
      }
      alt="Tronweb Rentals Logo"
      width={{ base: "140px", md: "160px" }}
      height="auto"
      {...props}
    />
  );
};

const SocialButton = ({ children, label, href }) => {
  return (
    <chakra.button
      bg={useColorModeValue("blackAlpha.100", "whiteAlpha.100")}
      rounded="full"
      w={{ base: 8, md: 10 }}
      h={{ base: 8, md: 10 }}
      cursor="pointer"
      as="a"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      transition="all 0.3s ease"
      _hover={{
        bg: "#f70112",
        color: "white",
        transform: "translateY(-2px)",
      }}
      fontSize={{ base: "md", md: "lg" }}
    >
      <VisuallyHidden>{label}</VisuallyHidden>
      {children}
    </chakra.button>
  );
};

const ListHeader = ({ children }) => {
  return (
    <Text fontWeight="600" fontSize={{ base: "md", md: "lg" }} mb={2} color={useColorModeValue("#f70112", "#ff4757")}>
      {children}
    </Text>
  );
};

export default function Footer() {
  return (
    <Box
      bg={useColorModeValue("gray.50", "gray.900")}
      color={useColorModeValue("gray.700", "gray.200")}
      borderTop="1px"
      borderColor={useColorModeValue("gray.200", "gray.700")}
      mt="auto"
    >
      <Container maxW="7xl" py={{ base: 8, md: 12 }}>
        {/* Main Footer Content */}
        <SimpleGrid
          columns={{ base: 1, sm: 2, md: 3 }}
          spacing={{ base: 8, md: 12 }}
          mb={{ base: 6, md: 8 }}
        >
          {/* Logo and Description */}
          <VStack align={{ base: "center", sm: "flex-start" }} spacing={4}>
            <Logo />
            <Text
              fontSize={{ base: "sm", md: "md" }}
              textAlign={{ base: "center", sm: "left" }}
              maxW={{ base: "280px", md: "320px" }}
              lineHeight="1.6"
            >
              Your trusted platform for TRX staking and resource rental with competitive returns.
            </Text>
          </VStack>

          {/* Quick Links */}
          <VStack align={{ base: "center", sm: "flex-start" }} spacing={4}>
            <ListHeader>Quick Links</ListHeader>
            <VStack align={{ base: "center", sm: "flex-start" }} spacing={2}>
              <Link
                href="/terms"
                fontSize={{ base: "sm", md: "md" }}
                _hover={{ color: "#f70112", textDecoration: "underline" }}
                transition="all 0.2s"
              >
                Terms of Service
              </Link>
              <Link
                href="/privacy"
                fontSize={{ base: "sm", md: "md" }}
                _hover={{ color: "#f70112", textDecoration: "underline" }}
                transition="all 0.2s"
              >
                Privacy Policy
              </Link>
            </VStack>
          </VStack>

          {/* Social Links */}
          <VStack align={{ base: "center", sm: "flex-start" }} spacing={4}>
            <ListHeader>Connect With Us</ListHeader>
            <HStack spacing={4}>
              <SocialButton label="Twitter" href="https://x.com/tronweb_io">
                <FaTwitter />
              </SocialButton>
              <SocialButton label="Telegram" href="https://t.me/tronweb_resource">
                <FaTelegram />
              </SocialButton>
            </HStack>
          </VStack>
        </SimpleGrid>

        {/* Divider */}
        <Divider borderColor={useColorModeValue("gray.300", "gray.600")} />

        {/* Bottom Bar */}
        <Flex
          direction={{ base: "column", md: "row" }}
          justify={{ base: "center", md: "space-between" }}
          align="center"
          pt={{ base: 6, md: 8 }}
          gap={{ base: 4, md: 0 }}
        >
          <Text fontSize={{ base: "xs", md: "sm" }} textAlign="center">
            © {new Date().getFullYear()} Tronweb Rentals. All rights reserved.
          </Text>
          <Text fontSize={{ base: "xs", md: "sm" }} textAlign="center" color={useColorModeValue("gray.500", "gray.400")}>
            Built with ❤️ for the TRON ecosystem
          </Text>
        </Flex>
      </Container>
    </Box>
  );
}
